import React, { useState } from 'react';
import { MapPinIcon, CubeIcon, BuildingOffice2Icon, BeakerIcon, LinkIcon } from "@heroicons/react/24/solid";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahAtAGlance.css";

const MinesPage = () => {

    const [searchTerm, setSearchTerm] = useState("");

    const minesData = [
        {
            "Mine Name": "Bingham Canyon Mine (Kennecott Mine)",
            "Location": "Oquirrh Mountains, SW of Salt Lake City",
            "Minerals Extracted": "Copper, Gold, Silver, Molybdenum",
            "Type": "Open Pit, Underground",
            "Owner/Operator (if known)": "Rio Tinto Kennecott",
            "Notes": "One of the largest open-pit mines in the world, and considered one of the most productive. Has been in operation since 1906. Also produces tellurium and rhenium as byproducts.",
            "Website Link (Owner/Parent Co.)": "https://www.riotinto.com/en/operations/us/kennecott"
        },
        {
            "Mine Name": "Utah Operations",
            "Location": "Stansbury Island, Great Salt Lake",
            "Minerals Extracted": "Magnesium metal, Chlorine, Potash",
            "Type": "Evaporation Ponds",
            "Owner/Operator (if known)": "US Magnesium",
            "Notes": "Extracts magnesium from the brine of the Great Salt Lake.",
            "Website Link (Owner/Parent Co.)": "https://www.usmagnesium.com/"
        },
        {
            "Mine Name": "Sufco Mine",
            "Location": "Sevier County",
            "Minerals Extracted": "Coal",
            "Type": "Underground",
            "Owner/Operator (if known)": "Wolverine Fuels",
            "Notes": "A major coal producer in Utah.",
            "Website Link (Owner/Parent Co.)": "https://wolverinefuels.com/"
        },
        {
            "Mine Name": "Skyline Mine",
            "Location": "Carbon/Emery County",
            "Minerals Extracted": "Coal",
            "Type": "Underground",
            "Owner/Operator (if known)": "Wolverine Fuels",
            "Notes": "Another significant underground coal mine in Utah.",
            "Website Link (Owner/Parent Co.)": "https://wolverinefuels.com/"
        },
        {
            "Mine Name": "Dugout Canyon Mine",
            "Location": "Carbon County",
            "Minerals Extracted": "Coal",
            "Type": "Underground",
            "Owner/Operator (if known)": "Wolverine Fuels",
            "Notes": "Part of Utah's active coal mining operations.",
            "Website Link (Owner/Parent Co.)": "https://wolverinefuels.com/"
        },
        {
            "Mine Name": "American Gilsonite Company",
            "Location": "Uinta Basin, Northeastern Utah",
            "Minerals Extracted": "Gilsonite",
            "Type": "Underground",
            "Owner/Operator (if known)": "American Gilsonite Company",
            "Notes": "Only commercial producer of Gilsonite® uintaite globally, a unique hydrocarbon used in various industrial applications.",
            "Website Link (Owner/Parent Co.)": "https://www.americangilsonite.com/"
        },
        {
            "Mine Name": "Tintic Mine",
            "Location": "Juab County",
            "Minerals Extracted": "Copper, Gold, Silver",
            "Type": "Underground",
            "Owner/Operator (if known)": "Ivanhoe Electric (Through their Utah Copper Division)",
            "Notes": "Another historically significant district for a variety of metals. While active mining is limited, exploration and smaller operations may occur.",
            "Website Link (Owner/Parent Co.)": "https://ivanhoeelectric.com/"
        },
        {
            "Mine Name": "Lisbon Valley Mine",
            "Location": "San Juan County",
            "Minerals Extracted": "Copper",
            "Type": "Open Pit (Heap Leach)",
            "Owner/Operator (if known)": "Lisbon Valley Mining Company",
            "Notes": "Known for its copper production in southeastern Utah, historically also associated with uranium.",
            "Website Link (Owner/Parent Co.)": "https://lisbonmine.com/"
        },
        {
            "Mine Name": "Topliff Mine / Spor Mountain Mine",
            "Location": "Juab County",
            "Minerals Extracted": "Beryllium (Bertrandite)",
            "Type": "Open Pit",
            "Owner/Operator (if known)": "Materion Natural Resources (Materion Corporation)",
            "Notes": "World's largest known beryllium resource and leading producer of beryllium metal in the US.",
            "Website Link (Owner/Parent Co.)": "https://materion.com/products/beryllium-and-beryllium-alloys"
        },
        {
            "Mine Name": "Tony M Mine",
            "Location": "Garfield County",
            "Minerals Extracted": "Uranium, Vanadium",
            "Type": "Underground",
            "Owner/Operator (if known)": "IsoEnergy Ltd.",
            "Notes": "A fully permitted, past‑producing underground uranium mine rehabbed in 2024–25; ready for restart targeting domestic uranium supply",
            "Website Link (Owner/Parent Co.)": "https://isoenergy.ca/"
        },
        {
            "Mine Name": "Daneros Mine",
            "Location": "San Juan County",
            "Minerals Extracted": "Uranium, Vanadium",
            "Type": "Underground",
            "Owner/Operator (if known)": "IsoEnergy Ltd.",
            "Notes": "A newer uranium mine that feeds the White Mesa Mill; currently on standby due to market conditions.",
            "Website Link (Owner/Parent Co.)": "https://isoenergy.ca/"
        },
        {
            "Mine Name": "Wilberg Mine",
            "Location": "Emery County",
            "Minerals Extracted": "Coal",
            "Type": "Underground",
            "Owner/Operator (if known)": "PacifiCorp",
            "Notes": "Site of Utah’s worst coal mine disaster in 1984",
            "Website Link (Owner/Parent Co.)": "N/A"
        },
        {
            "Mine Name": "Mercur Mine",
            "Location": "Tooele County",
            "Minerals Extracted": "Gold, Silver",
            "Type": "Open-pit",
            "Owner/Operator (if known)": "Barrick Gold (closed in 1997)",
            "Notes": "First cyanide-based gold extraction in the U.S. in 1890s",
            "Website Link (Owner/Parent Co.)": "https://www.barrick.com/"
        },
        {
            "Mine Name": "Ontario Mine",
            "Location": "Park City, Summit County",
            "Minerals Extracted": "Silver, Lead, Zinc",
            "Type": "Underground",
            "Owner/Operator (if known)": "Historic",
            "Notes": "Operated 1872–1964, major historic silver mine",
            "Website Link (Owner/Parent Co.)": "N/A"
        },
        {
            "Mine Name": "Topaz Beryllium Mine",
            "Location": "Near Delta, Juab County",
            "Minerals Extracted": "Beryllium",
            "Type": "Open-pit",
            "Owner/Operator (if known)": "Materion Corporation",
            "Notes": "Only primary beryllium producer in the U.S.",
            "Website Link (Owner/Parent Co.)": "https://materion.com/"
        },
        {
            "Mine Name": "White Mesa Mill",
            "Location": "Blanding, San Juan County",
            "Minerals Extracted": "Uranium, Vanadium (processing mill, fed by various mines)",
            "Type": "Processing Mill (historical/on standby)",
            "Owner/Operator (if known)": "Energy Fuels Resources",
            "Notes": "Only conventional uranium mill operating in the U.S.; also processes rare earths.",
            "Website Link (Owner/Parent Co.)": "https://www.energyfuels.com/"
        },
        {
            "Mine Name": "Rim Mine",
            "Location": "San Juan County",
            "Minerals Extracted": "Uranium, Vanadium",
            "Type": "Underground",
            "Owner/Operator (if known)": "IsoEnergy Ltd.",
            "Notes": "High-grade uranium/vanadium resource; near White Mesa Mill.",
            "Website Link (Owner/Parent Co.)": "https://isoenergy.ca/"
        },
        {
            "Mine Name": "Velvet-Wood Mine",
            "Location": "San Juan County",
            "Minerals Extracted": "Uranium, Vanadium",
            "Type": "Underground",
            "Owner/Operator (if known)": "Anfield Energy",
            "Notes": "Revitalized historic uranium mine near Lisbon Valley.",
            "Website Link (Owner/Parent Co.)": "https://anfieldenergy.com/"
        },
        {
            "Mine Name": "Coal Hollow Mine",
            "Location": "Kane County",
            "Minerals Extracted": "Coal",
            "Type": "Surface",
            "Owner/Operator (if known)": "Alton Coal Development / Wolverine Fuels",
            "Notes": "Operates on private and public land; provides fuel to Utah power plants.",
            "Website Link (Owner/Parent Co.)": "https://wolverinefuels.com/"
        },
        {
            "Mine Name": "Potash Pros / Intrepid Potash",
            "Location": "Moab, Grand County",
            "Minerals Extracted": "Potash (Muriate of Potash), Salt",
            "Type": "Solution Mining",
            "Owner/Operator (if known)": "Intrepid Potash, Inc.",
            "Notes": "Largest producer of potash in the U.S.; uses solar evaporation near Moab.",
            "Website Link (Owner/Parent Co.)": "https://www.intrepidpotash.com/"
        },
        {
            "Mine Name": "Solar Salt Operations",
            "Location": "Various locations, Great Salt Lake",
            "Minerals Extracted": "Salt (Sodium Chloride)",
            "Type": "Evaporation Ponds",
            "Owner/Operator (if known)": "Multiple (e.g., Morton Salt)",
            "Notes": "Harvests minerals from brine using natural evaporation.",
            "Website Link (Owner/Parent Co.)": "https://www.mortonsalt.com/"
        },
        {
            "Mine Name": "Little Cottonwood Canyon Quarries",
            "Location": "Little Cottonwood Canyon, Wasatch Range",
            "Minerals Extracted": "Quartz Monzonite (Dimension Stone)",
            "Type": "Quarry",
            "Owner/Operator (if known)": "Various local companies",
            "Notes": "Provided stone for Utah Capitol & LDS Temple; some sites still used.",
            "Website Link (Owner/Parent Co.)": "N/A"
        },
        {
            "Mine Name": "Various Sand & Gravel Pits",
            "Location": "Across Utah (e.g., Salt Lake, Utah County)",
            "Minerals Extracted": "Sand, Gravel, Aggregate",
            "Type": "Open Pit (Quarry)",
            "Owner/Operator (if known)": "Numerous local companies",
            "Notes": "Common construction material sources; essential for roads, concrete, and more.",
            "Website Link (Owner/Parent Co.)": "https://www.genevarock.com/"
        },
        {
            "Mine Name": "Cement Plants & Quarries",
            "Location": "Various locations (e.g., Lehi)",
            "Minerals Extracted": "Limestone, Clay (for Cement)",
            "Type": "Quarry",
            "Owner/Operator (if known)": "Various (e.g., Ash Grove Cement)",
            "Notes": "Supply cement for Utah construction; large-scale industrial operations.",
            "Website Link (Owner/Parent Co.)": "https://ashgrove.com/"
        },
        {
            "Mine Name": "Mercur Gold Project",
            "Location": "Tooele County",
            "Minerals Extracted": "Gold",
            "Type": "Open Pit",
            "Owner/Operator (if known)": "Revival Gold Inc.",
            "Notes": "Proposed environmentally friendly gold extraction using water-based solutions.",
            "Website Link (Owner/Parent Co.)": "https://revival-gold.com/"
        }

    ];

    const filteredMines = minesData.filter((mine) =>
        Object.values(mine)
            .join(" ")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    return (
        // <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
        //     {/* Landing Section */}
        //     <LandingSection
        //         data={{
        //             imageName: "utahMines.jpg",
        //             title: `Utah's Major Mines`,
        //             visible: true
        //         }}
        //     />

        //     {/* Mines List */}
        //     <div className="container mx-auto px-4 py-8">
        //         {/* <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-blue-800">
        //             Major Mines in Utah
        //         </h2> */}

        //         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        //             {minesData.map((mine, index) => (
        //                 <div
        //                     key={index}
        //                     className="bg-white shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] rounded-xl p-6 hover:shadow-[0_8px_24px_0_rgba(1,76,178,0.3)] transition duration-300 hover:scale-105 transform flex flex-col"
        //                 >
        //                     <h3 className="text-xl font-semibold text-blue-700 mb-4 text-center">
        //                         {mine['Mine Name']}
        //                     </h3>

        //                     <div className="flex flex-col gap-3 text-sm text-gray-700">
        //                         <div className="flex items-start">
        //                             <MapPinIcon className="h-5 w-5 text-blue-600 mt-0.5 mr-2 shrink-0" />
        //                             <div>
        //                                 <span className="font-semibold">Location: </span>
        //                                 {mine.Location}
        //                             </div>
        //                         </div>

        //                         <div className="flex items-start">
        //                             <CubeIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 shrink-0" />
        //                             <div>
        //                                 <span className="font-semibold">Minerals: </span>
        //                                 {mine['Minerals Extracted']}
        //                             </div>
        //                         </div>

        //                         <div className="flex items-start">
        //                             <BeakerIcon className="h-5 w-5 text-purple-600 mt-0.5 mr-2 shrink-0" />
        //                             <div>
        //                                 <span className="font-semibold">Type: </span>
        //                                 {mine.Type}
        //                             </div>
        //                         </div>

        //                         <div className="flex items-start">
        //                             <BuildingOffice2Icon className="h-5 w-5 text-yellow-600 mt-0.5 mr-2 shrink-0" />
        //                             <div>
        //                                 <span className="font-semibold">Owner: </span>
        //                                 {mine['Owner/Operator (if known)']}
        //                             </div>
        //                         </div>

        //                         <div className="flex items-start">
        //                             <div className="h-5 w-5 mr-2 mt-0.5 text-gray-600 flex items-center justify-center shrink-0">
        //                                 📝
        //                             </div>
        //                             <div>{mine.Notes}</div>
        //                         </div>

        //                         {/* {mine['Website Link (Owner/Parent Co.)'] && (
        //                             <div className="flex items-center">
        //                                 <LinkIcon className="h-5 w-5 text-blue-500 mr-2 shrink-0" />
        //                                 <a
        //                                     href={mine['Website Link (Owner/Parent Co.)']}
        //                                     target="_blank"
        //                                     rel="noopener noreferrer"
        //                                     className="text-blue-600 underline"
        //                                 >
        //                                     Visit Official Site →
        //                                 </a>
        //                             </div>
        //                         )} */}

        //                         {mine['Website Link (Owner/Parent Co.)'] !== "N/A" && mine['Website Link (Owner/Parent Co.)'].trim() !== "" && (
        //                             <div className="flex items-center">
        //                                 <LinkIcon className="h-5 w-5 text-blue-500 mr-2 shrink-0" />
        //                                 <a
        //                                     href={mine['Website Link (Owner/Parent Co.)']}
        //                                     target="_blank"
        //                                     rel="noopener noreferrer"
        //                                     className="text-blue-600 underline"
        //                                 >
        //                                     Visit Official Site →
        //                                 </a>
        //                             </div>
        //                         )}

        //                     </div>
        //                 </div>
        //             ))}
        //         </div>
        //     </div>

        //     <Footer />
        // </div>

        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{
                    imageName: "mines.webp",
                    title: `Utah's Major Mines`,
                    visible: true,
                }}
            />

            <div className="utah-at-a-glance-section">
                <div className="utah-at-a-glance-intro">
                    <div className="utah-at-a-glance-intro-sec1">
                        <h2>
                            Utah’s Major Mines: Digging into Economic Powerhouses
                        </h2>
                    </div>
                    <div className="utah-at-a-glance-intro-sec2">
                        <p>
                            Uncover the industrial heart of Utah with a detailed look at its major mines.
                            From precious metals to industrial minerals, these operations not only shape
                            the landscape but also fuel local and global economies. Explore locations,
                            ownerships, and the resources that keep Utah digging deep into the future.
                        </p>
                    </div>
                </div>
            </div>

            {/* Search Input */}
            <div className="w-full px-4 sm:px-8 md:px-16 mt-4 flex justify-center">
                <input
                    type="text"
                    placeholder="Search by keyword (e.g., copper, owner, location)..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full max-w-2xl px-4 py-2 border border-blue-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
                />
            </div>

            {/* Mines List */}
            <div className="container mx-auto px-4 py-8">
                {filteredMines.length === 0 ? (
                    <p className="text-center text-red-500 mt-6">
                        No mines found for "{searchTerm}"
                    </p>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {filteredMines.map((mine, index) => (
                            <div
                                key={index}
                                className="bg-white shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] rounded-xl p-6 hover:shadow-[0_8px_24px_0_rgba(1,76,178,0.3)] transition duration-300 hover:scale-105 transform flex flex-col"
                            >
                                <h3 className="text-xl font-semibold text-blue-700 mb-4 text-center">
                                    {mine["Mine Name"]}
                                </h3>

                                <div className="flex flex-col gap-3 text-sm text-gray-700">
                                    <div className="flex items-start">
                                        <MapPinIcon className="h-5 w-5 text-blue-600 mt-0.5 mr-2 shrink-0" />
                                        <div>
                                            <span className="font-semibold">Location: </span>
                                            {mine.Location}
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <CubeIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 shrink-0" />
                                        <div>
                                            <span className="font-semibold">Minerals: </span>
                                            {mine["Minerals Extracted"]}
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <BeakerIcon className="h-5 w-5 text-purple-600 mt-0.5 mr-2 shrink-0" />
                                        <div>
                                            <span className="font-semibold">Type: </span>
                                            {mine.Type}
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <BuildingOffice2Icon className="h-5 w-5 text-yellow-600 mt-0.5 mr-2 shrink-0" />
                                        <div>
                                            <span className="font-semibold">Owner: </span>
                                            {mine["Owner/Operator (if known)"]}
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="h-5 w-5 mr-2 mt-0.5 text-gray-600 flex items-center justify-center shrink-0">
                                            📝
                                        </div>
                                        <div><span className="font-semibold">Additional Info: </span>{mine.Notes}</div>
                                    </div>

                                    {mine["Website Link (Owner/Parent Co.)"] !== "N/A" &&
                                        mine["Website Link (Owner/Parent Co.)"].trim() !== "" && (
                                            <div className="flex items-center">
                                                <LinkIcon className="h-5 w-5 text-blue-500 mr-2 shrink-0" />
                                                <a
                                                    href={mine["Website Link (Owner/Parent Co.)"]}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 underline"
                                                >
                                                    Visit Official Site →
                                                </a>
                                            </div>
                                        )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default MinesPage;
